<script setup lang="ts">

</script>

<template>
    <div class="flex overflow-x-auto overflow-y-hidden -mx-4 px-4 scroll-px-4 border-b border-neutral-200 space-x-8 sm:mx-0 sm:px-0 sm:scroll-px-0 lg:hidden">
        <slot />
    </div>
</template>

